import React from "react";
import About from "./About";
import Blogs from "./Blogs";
import Contact from "./Contact";
import Features2 from "./Features2";
import HeroSection from "./HeroSection";
import Launching from "./Launching";
import Offer from "./Offer";
import OurProcess from "./OurProcess";
import Stats from "./Stats";
import Pricing from "./Pricing";
import Features from "./Features";

type Props = {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const HomePage = ({ setIsOpen }: Props) => {
  return (
    <div className="flex flex-col overflow-hidden mx-auto max-w-screen-2xl items-center justify-center">
      <HeroSection setIsOpen={setIsOpen} />
      <About />
      <Offer />
      <Features />
      <Launching />
      <Stats />
      <OurProcess />
      <Pricing />
      <Contact />
      <Blogs />
    </div>
  );
};

export default HomePage;
